"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveUpdatesService = exports.LiveUpdatesServiceLogger = exports.LiveUpdatesServiceConfig = exports.LiveUpdatesServiceNetwork = exports.ActualSHAProvider = exports.LocationProvider = exports.LatestLiveUpdateVersionProvider = exports.AppInfoProvider = void 0;
var state_1 = require("@meraki-internal/state");
var capacitor_updater_1 = require("@capgo/capacitor-updater");
var app_1 = require("@capacitor/app");
var device_1 = require("@capacitor/device");
var dayjs_1 = __importDefault(require("dayjs"));
var StorageProvider_1 = require("./StorageProvider");
var AppInfoProvider = /** @class */ (function () {
    function AppInfoProvider() {
        var _this = this;
        this.getAppInfo = function () { return __awaiter(_this, void 0, void 0, function () {
            var deviceInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, device_1.Device.getInfo()];
                    case 1:
                        deviceInfo = _a.sent();
                        if (deviceInfo.platform === 'web') {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, app_1.App.getInfo()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
    }
    return AppInfoProvider;
}());
exports.AppInfoProvider = AppInfoProvider;
var LatestLiveUpdateVersionProvider = /** @class */ (function () {
    function LatestLiveUpdateVersionProvider() {
        var _this = this;
        this.getLatestVersionAvailable = function (url) { return __awaiter(_this, void 0, void 0, function () {
            var res, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(url)];
                    case 1:
                        res = _a.sent();
                        if (!(res.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, res.json()];
                    case 2:
                        body = _a.sent();
                        return [2 /*return*/, body];
                    case 3: throw new Error("".concat(res.status, " GET ").concat(url));
                }
            });
        }); };
    }
    return LatestLiveUpdateVersionProvider;
}());
exports.LatestLiveUpdateVersionProvider = LatestLiveUpdateVersionProvider;
var LocationProvider = /** @class */ (function () {
    function LocationProvider() {
        this.getHash = function () { return window.location.hash; };
    }
    return LocationProvider;
}());
exports.LocationProvider = LocationProvider;
var CapacitorUpdaterProvider = /** @class */ (function () {
    function CapacitorUpdaterProvider() {
        this.getUpdater = function () { return capacitor_updater_1.CapacitorUpdater; };
    }
    return CapacitorUpdaterProvider;
}());
var ActualSHAProvider = /** @class */ (function () {
    function ActualSHAProvider() {
        throw new Error('ActualSHAProvider should be set via IOC');
    }
    return ActualSHAProvider;
}());
exports.ActualSHAProvider = ActualSHAProvider;
// This gets swapped out in IOC by Network
// We are not using that directly here, because it indirectly depends on tsx and causes mocha
// to fail
var LiveUpdatesServiceNetwork = /** @class */ (function () {
    function LiveUpdatesServiceNetwork() {
        this.isOnline = true;
        throw new Error('see ioc');
    }
    return LiveUpdatesServiceNetwork;
}());
exports.LiveUpdatesServiceNetwork = LiveUpdatesServiceNetwork;
var LiveUpdatesServiceConfig = /** @class */ (function () {
    function LiveUpdatesServiceConfig() {
        throw new Error('LiveUpdatesServiceConfig should be set via IOC');
    }
    return LiveUpdatesServiceConfig;
}());
exports.LiveUpdatesServiceConfig = LiveUpdatesServiceConfig;
var LiveUpdatesServiceLogger = /** @class */ (function () {
    function LiveUpdatesServiceLogger() {
        throw new Error('LiveUpdatesServiceLogger should be set via IOC');
    }
    return LiveUpdatesServiceLogger;
}());
exports.LiveUpdatesServiceLogger = LiveUpdatesServiceLogger;
var LiveUpdatesService = /** @class */ (function (_super) {
    __extends(LiveUpdatesService, _super);
    function LiveUpdatesService(config, appInfoProvider, capacitorUpdaterProvider, latestLiveUpdateVersionProvider, logger, actualSHAProvider, moreStorage, network) {
        var _this = _super.call(this, {}) || this;
        _this.config = config;
        _this.appInfoProvider = appInfoProvider;
        _this.latestLiveUpdateVersionProvider = latestLiveUpdateVersionProvider;
        _this.logger = logger;
        _this.actualSHAProvider = actualSHAProvider;
        _this.moreStorage = moreStorage;
        _this.network = network;
        _this.lastInstalledLiveUpdateVersionStorage = _this.moreStorage.getAsyncStringProvider('LiveUpdatesService.lastInstalledLiveUpdateVersion', { envNeutral: false, userNeutral: true, storageType: 'localStorage', maxBytes: 1000000, removeOnTooBig: true });
        _this.isDownloading = false;
        _this.isInstalling = false;
        /**
         * Returns the native version, eg 1.6.3
         * which is what live updates get applied to
         * Since this class is only ever used on a real device it will always return a value
         */
        _this.getNativeVersion = function () { return _this.nativeVersion; };
        _this.disableInstallOrDownloadUpdateIfAvailable = false;
        _this._init = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, appInfo;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    // we have to call this within the first 10s of our app starting, or the live update
                    // will be assumed bad, and will be rolled back
                    return [4 /*yield*/, this.capacitorUpdater.notifyAppReady()];
                    case 1:
                        // we have to call this within the first 10s of our app starting, or the live update
                        // will be assumed bad, and will be rolled back
                        _b.sent();
                        this.capacitorUpdater.addListener('updateFailed', function (e) {
                            _this.logger.error("got updateFailed ".concat(JSON.stringify(e.bundle)));
                        });
                        _a = this;
                        return [4 /*yield*/, this.lastInstalledLiveUpdateVersionStorage.get()];
                    case 2:
                        _a.lastInstalledLiveUpdateVersion = _b.sent();
                        return [4 /*yield*/, this.appInfoProvider.getAppInfo()];
                    case 3:
                        appInfo = _b.sent();
                        if (!appInfo) {
                            throw new Error('WARN: LiveUpdatesService was initialized without AppInfo, likely not on a device, which should not have been possible, see AppContainer');
                        }
                        this.nativeVersion = appInfo.version;
                        return [4 /*yield*/, Promise.all([
                                this.fetchBundles(),
                                this.fetchLatestVersionAvailable()
                            ])];
                    case 4:
                        _b.sent();
                        // intentionally not waiting, it has error handling built in
                        this.checkForErrorBundles();
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Init fails gracefully such that
         * 1. an error will be sent to sentry
         * 2. if we failed to load native version, bundles, or latestAvailable
         *    then the status will be initializing and
         *    therefore downloadUpdateIfAvailable will no op
         *    and installOrDownloadUpdateIfAvailable will no op
         *    until the next app start where it can try to init again
         *    If, the thing the failed was this.latestVersionAvailable then it likely
         *    will correct itself over time, as it will retry every hash change
         */
        _this.init = function (_a) {
            var _b = _a === void 0 ? {} : _a, disableInstallOrDownloadUpdateIfAvailable = _b.disableInstallOrDownloadUpdateIfAvailable;
            return __awaiter(_this, void 0, void 0, function () {
                var err_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.disableInstallOrDownloadUpdateIfAvailable = disableInstallOrDownloadUpdateIfAvailable === true;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this._init()];
                        case 2:
                            _c.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _c.sent();
                            this.logger.error("LiveUpdatesService.init failed, allowing app to proceed but won't support live updates. Error: ".concat(err_1.toString()));
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        _this.enable = function () {
            _this.disableInstallOrDownloadUpdateIfAvailable = false;
        };
        _this.disable = function () {
            _this.disableInstallOrDownloadUpdateIfAvailable = true;
        };
        _this.downloadUpdateIfAvailable = function () { return __awaiter(_this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.disableInstallOrDownloadUpdateIfAvailable) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.fetchLatestVersionAvailable()];
                    case 2:
                        _a.sent();
                        if (!(this.getLiveUpdateStatus() === 'live-update-available')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.downloadLatest()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_2 = _a.sent();
                        if (this.network.isOnline) {
                            this.logger.error("WARNING: LiveUpdatesService.downloadUpdateIfAvailable failed with ".concat(err_2.toString()));
                        }
                        else {
                            this.logger.info("LiveUpdatesService.downloadUpdateIfAvailable failed with ".concat(err_2.toString(), " while network is offline"));
                        }
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.installOrDownloadUpdateIfAvailable = function () { return __awaiter(_this, void 0, void 0, function () {
            var err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.disableInstallOrDownloadUpdateIfAvailable) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        if (!(this.getLiveUpdateStatus() === 'downloaded')) return [3 /*break*/, 5];
                        if (!(this.getLiveUpdateStatus() === 'downloaded')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.config.onInstallingLiveUpdate()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.installLatest()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        // downloading should always happen in the background, so don't await here
                        this.downloadUpdateIfAvailable();
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_3 = _a.sent();
                        this.logger.error("WARNING: LiveUpdatesService.installOrDownloadUpdateIfAvailable failed with ".concat(err_3.toString()));
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        // Returns the full version, eg 1.6.3.de6aa22
        // If there is a live update installed, it will return that, even if running locally, in which case it is NOT
        // the actual version. If no live update is installed, it will return the actual version (the version shipped with the native build);
        _this.getInstalledVersion = function () {
            var currentBundle = _this.getCurrentBundle();
            return currentBundle ? currentBundle.version : _this.getActualVersion();
        };
        // Returns the full version, eg 1.6.3.de6aa22
        // This uses the SHA that was harded coded into the build.
        // The only time this will be different than getInstalledVersion
        // is when running locally, because then the version of JS we're running
        // is different than the live update that is installed.
        _this.getActualVersion = function () {
            return "".concat(_this.getNativeVersion() || '', ".").concat(_this.getActualShortSHA());
        };
        _this.getActualSHA = function () { return _this.actualSHAProvider.getSHA(); };
        _this.getActualShortSHA = function () { return _this.getActualSHA().substring(0, 7); };
        _this.getAvailableLiveUpdateUrl = function () {
            var nativeVersion = _this.getNativeVersion();
            var env = _this.config.ENV === 'production' ? 'production' : 'staging';
            var baseUrl = _this.trimTrailingSlash(_this.config.LIVE_UPDATES_BASE_URL);
            return "".concat(baseUrl, "/").concat(nativeVersion, "/").concat(env, "-latest.json");
        };
        _this.trimTrailingSlash = function (url) {
            if (url.endsWith('/')) {
                return url.substring(0, url.length - 1);
            }
            else {
                return url;
            }
        };
        _this.getLiveUpdateStatus = function () {
            if (!_this.latestVersionAvailable || !_this.bundles) {
                return 'initializing';
            }
            if (_this.isInstalling) {
                return 'installing';
            }
            if (_this.isDownloading) {
                return 'downloading';
            }
            var latestVersionAvailable = _this.latestVersionAvailable;
            if (!latestVersionAvailable.url) {
                // if there isn't a url, because its an "empty" live update
                // to avoid 404 caching, then there isn't a latest live update to compare to
                latestVersionAvailable = undefined;
            }
            var current = _this.getCurrentBundle();
            var currentVersion = (current === null || current === void 0 ? void 0 : current.version) || "".concat(_this.getNativeVersion() || '', ".").concat((_this.actualSHAProvider.getSHA()).substring(0, 7)) || "";
            if (!latestVersionAvailable) {
                return 'up-to-date';
            }
            else if (currentVersion === _this.latestVersionAvailable.version) {
                return 'up-to-date';
            }
            var latestVersionAvailableGuaranteed = latestVersionAvailable;
            // technically there could be more than one bundle for a single version
            // this state machine should make that verify difficult, but alas, we should handle it just in case
            var latestVersionAvailableBundles = _this.bundles.filter(function (b) { return b.version === latestVersionAvailableGuaranteed.version; });
            // if there is one that is installed, that one should win
            var latestVersionAvailableBundle = latestVersionAvailableBundles.find(function (b) { return b.status === 'success'; });
            if (!latestVersionAvailableBundle) {
                // if there is one ready to install, use it
                latestVersionAvailableBundle = latestVersionAvailableBundles.find(function (b) { return b.status === 'pending'; });
            }
            if (latestVersionAvailableBundle && latestVersionAvailableBundle.status === 'pending' && _this.lastInstalledLiveUpdateVersion === latestVersionAvailableBundle.version) {
                return 'up-to-date';
            }
            if (!latestVersionAvailableBundle) {
                // if there is one downloading, use it
                latestVersionAvailableBundle = latestVersionAvailableBundles.find(function (b) { return b.status === 'downloading'; });
            }
            // if we already tried the "latest" and it failed, then we don't want to update again until there is a new live update
            if (latestVersionAvailableBundles.find(function (b) { return b.status === 'error'; })) {
                return 'up-to-date';
            }
            if (!latestVersionAvailableBundle) {
                return 'live-update-available';
            }
            if (latestVersionAvailableBundle.status === 'downloading') {
                return 'downloading';
            }
            if (latestVersionAvailableBundle.status === 'pending') {
                return 'downloaded';
            }
            // shouldn't get this far, but if we do, assume something is wrong and let them redownload it
            return 'live-update-available';
        };
        _this.downloadLatest = function () { return __awaiter(_this, void 0, void 0, function () {
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.getLiveUpdateStatus() !== 'live-update-available') {
                            throw new Error("cannot download, status is ".concat(this.getLiveUpdateStatus()));
                        }
                        if (!this.network.isOnline) {
                            this.logger.info('attempted downloadLatest, but skipping because offline');
                            return [2 /*return*/];
                        }
                        // we are setting are our flag that we are downloading so we can synchronously
                        // know that a download has started, otherwise we're dependent on
                        // learning it from capacitorUpdater.list which is inherently async
                        // and therefore there would be a race condition where mulitiple downloads could
                        // could triggered in parallel
                        this.isDownloading = true;
                        this.setState({});
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        if (!this.latestVersionAvailable) {
                            throw new Error('expected this.latestVersionAvailable to be defined');
                        }
                        if (!this.latestVersionAvailable.url) {
                            // there isn't anything to download, eg because the version was created but no live update deployed yet
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.capacitorUpdater.download({
                                url: this.latestVersionAvailable.url,
                                version: this.latestVersionAvailable.version
                            })];
                    case 2:
                        _a.sent();
                        // intentionally not waiting
                        this.cleanupDeadBundles();
                        return [4 /*yield*/, this.fetchBundles()];
                    case 3:
                        _a.sent();
                        this.setState({});
                        return [3 /*break*/, 6];
                    case 4:
                        err_4 = _a.sent();
                        throw new Error("CapacitorUpdater.download ".concat(JSON.stringify(this.latestVersionAvailable), " failed with Error: ").concat(err_4.toString()));
                    case 5:
                        this.isDownloading = false;
                        this.setState({});
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.refreshLatestAvailableLiveUpdate = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchLatestVersionAvailable()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * This will show the splash screen, then initiate install of the alreaded downloaded zip file.
         *
         * It should take hundreds of ms to swap in the new web view, at which point our javascript is no longer running.
         *
         * The new version of the app, will then need to hide the splash screen.
         */
        _this.installLatest = function () { return __awaiter(_this, void 0, void 0, function () {
            var status, latestAvailableBundle, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        status = this.getLiveUpdateStatus();
                        if (status !== 'downloaded') {
                            throw new Error("cannot install latest b/c it is not downloaded yet, current status is ".concat(status));
                        }
                        latestAvailableBundle = this.getLatestAvailableBundle();
                        if (!latestAvailableBundle) {
                            throw new Error("cannot install latest b/c it the bundle doesn't exist");
                        }
                        this.isInstalling = true;
                        this.setState({});
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        // set the in memory version, just in case
                        this.lastInstalledLiveUpdateVersion = latestAvailableBundle.version;
                        // set the storage version, so if this installs, and then reverts, we know not to try and install it again
                        return [4 /*yield*/, this.lastInstalledLiveUpdateVersionStorage.set(latestAvailableBundle.version)];
                    case 2:
                        // set the storage version, so if this installs, and then reverts, we know not to try and install it again
                        _a.sent();
                        return [4 /*yield*/, this.capacitorUpdater.set({ id: latestAvailableBundle.id })];
                    case 3:
                        _a.sent();
                        // we lose control within ?1ms?, as the new JS app starts
                        // block indefinitely while app is reloading (in case capacitorUpdater doesn't do this for us)
                        return [4 /*yield*/, new Promise(function () { })];
                    case 4:
                        // we lose control within ?1ms?, as the new JS app starts
                        // block indefinitely while app is reloading (in case capacitorUpdater doesn't do this for us)
                        _a.sent(); // eslint-disable-line @typescript-eslint/no-empty-function
                        return [3 /*break*/, 6];
                    case 5:
                        err_5 = _a.sent();
                        this.isInstalling = false;
                        this.setState({});
                        throw err_5;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.getLatestAvailableBundle = function () {
            if (!_this.latestVersionAvailable) {
                return undefined;
            }
            if (!_this.latestVersionAvailable) {
                return undefined;
            }
            var latestVersionAvailable = _this.latestVersionAvailable;
            return (_this.bundles || []).find(function (b) { return b.version === latestVersionAvailable.version; });
        };
        _this.getCurrentBundle = function () {
            return (_this.bundles || []).find(function (b) { return b.status === 'success'; });
        };
        _this.fetchLatestVersionAvailable = function () { return __awaiter(_this, void 0, void 0, function () {
            var body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.getNativeVersion()) {
                            // then we failed to init, fail gracefully
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.latestLiveUpdateVersionProvider.getLatestVersionAvailable(this.getAvailableLiveUpdateUrl())];
                    case 1:
                        body = _a.sent();
                        this.latestVersionAvailable = __assign(__assign({}, body), { asOf: new Date().toISOString() });
                        this.setState({});
                        return [2 /*return*/];
                }
            });
        }); };
        _this.canDeleteBundle = function (bundle) {
            // cannot delete the currently installed bundle
            return bundle.status !== 'success';
        };
        _this.deleteBundle = function (bundle) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canDeleteBundle(bundle)) {
                            throw new Error("cannot delete bundle ".concat(JSON.stringify(bundle), " because it is the currently installed bundle. Install another bundle first"));
                        }
                        return [4 /*yield*/, this.capacitorUpdater.delete({ id: bundle.id })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchBundles()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.fetchBundles = function () { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.capacitorUpdater.list()];
                    case 1:
                        result = _a.sent();
                        this.bundles = result.bundles;
                        this.setState({});
                        return [2 /*return*/];
                }
            });
        }); };
        _this.showManagerLink = function () { return true; };
        /**
         * CapacitorUpdater will delete the old bundle when we install a new one.
         *
         * But it doesn't delete bundles that never get installed.
         */
        _this.cleanupDeadBundles = function () { return __awaiter(_this, void 0, void 0, function () {
            var twentyFourHoursAgo, _i, _a, bundle, err_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, , 7]);
                        twentyFourHoursAgo = (0, dayjs_1.default)().add(-24, 'hours').toISOString();
                        _i = 0, _a = (this.bundles || []);
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        bundle = _a[_i];
                        if (!(bundle.status === 'pending' && bundle.downloaded >= twentyFourHoursAgo)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.deleteBundle(bundle)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [4 /*yield*/, this.fetchBundles()];
                    case 5:
                        _b.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        err_6 = _b.sent();
                        this.logger.error("WARN: failed to clean up dead bundles. ".concat(err_6.toString()));
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        /**
         * I haven't actually seen bundles with status "error".
         *
         * Looking at the java source, it appears, that after a revert the bundle should have been changed to status error.
         * But when I tested this, it was still status pending
         *
         * Also, looking at the java source, it appears it should send us an event at this.capacitorUpdater.addListener('updateFailed'
         * but I didn't see the event in the logs. It isn't clear which runtime the java source is sending it to, the one that failed,
         * or the one it is reverting to. It is sending it to a queue, but I am doubtful its a queue that respects the fact that the
         * runtime might not even exist yet. I wouldn't be surprised if this feature is half baked and it is going to the one that it is
         * reverting to, before it exists, such that it never gets it.
         */
        _this.checkForErrorBundles = function () { return __awaiter(_this, void 0, void 0, function () {
            var errorBundles, _i, errorBundles_1, bundle, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        this.checkForErrorBundleStatusPending();
                        errorBundles = (this.bundles || []).filter(function (b) { return b.status === 'error'; });
                        _i = 0, errorBundles_1 = errorBundles;
                        _a.label = 1;
                    case 1:
                        if (!(_i < errorBundles_1.length)) return [3 /*break*/, 4];
                        bundle = errorBundles_1[_i];
                        this.logger.error("WARN: found bundle with error ".concat(JSON.stringify(bundle), " which is likely the result of reverting a live update"));
                        if (!(this.latestVersionAvailable && this.latestVersionAvailable.version !== bundle.version)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.deleteBundle(bundle)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [4 /*yield*/, this.fetchBundles()];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        err_7 = _a.sent();
                        this.logger.error("WARN: failed to clean up error bundles. ".concat(err_7.toString()));
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        _this.checkForErrorBundleStatusPending = function () {
            // if there isn't a latest live update, then it cannot have failed to install
            if (!_this.lastInstalledLiveUpdateVersion) {
                return;
            }
            // if the currently installed version is the last version we installed, then it didn't fail
            // this should be 99.9P
            if (_this.lastInstalledLiveUpdateVersion === _this.getInstalledVersion()) {
                return;
            }
            // otherwise we likely got reverted, but got no signal from CapacitorUpdater, let check for the "pending" bundle
            var latestAvailableBundles = (_this.bundles || []).filter(function (b) { var _a; return b.version === ((_a = _this.latestVersionAvailable) === null || _a === void 0 ? void 0 : _a.version) && b.status === 'pending'; });
            if (latestAvailableBundles.length > 0) {
                // lets lot to sentry so we're not blind to it
                _this.logger.error("it appears the install of ".concat(_this.lastInstalledLiveUpdateVersion, " was reverted to ").concat(_this.getActualVersion()));
            }
        };
        _this.capacitorUpdater = capacitorUpdaterProvider.getUpdater();
        return _this;
    }
    LiveUpdatesService.inject = function () { return [
        LiveUpdatesServiceConfig,
        AppInfoProvider,
        CapacitorUpdaterProvider,
        LatestLiveUpdateVersionProvider,
        LiveUpdatesServiceLogger,
        ActualSHAProvider,
        StorageProvider_1.StorageProvider,
        LiveUpdatesServiceNetwork,
    ]; };
    return LiveUpdatesService;
}(state_1.State));
exports.LiveUpdatesService = LiveUpdatesService;
//# sourceMappingURL=LiveUpdatesService.js.map